import React, { createContext, useState } from "react";
import moment from "moment";

const initialState = {
	activeRegionId: null,
	isYesterday: true,
	dateFilter: moment(new Date()).unix(),
	activeCompetitionId: null,
	resultData: { yesterday: null, today: null },
	config: null,
};

export const RacingsContext = createContext([initialState, {}]);

let _dispatcher, _state;
export const getRacingsState = () => _state;

export const getRacingsDispatcher = () => _dispatcher;

export const RacingsContextProvider = ({ config, children }) => {
	const [state, setState] = useState({ ...initialState, config });

	_dispatcher = setState;
	_state = state;

	return <RacingsContext.Provider value={[state, setState]}>{children}</RacingsContext.Provider>;
};
